import { HttpClient, HttpParams, HttpHeaders, HttpHeaderResponse } from '@angular/common/http';
import { Injector, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export abstract class BaseService {
  currentToken: any;
  private httpOptions: any = null;
  constructor(private http: HttpClient) {
    // this.currentToken = UIUtil.getPrivateData(session_keys.user).token;
    //'Content-Type': 'application/json',
    const headers: HttpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.httpOptions = { headers: headers };
  }

  protected getBaseUrl(): string {
    return environment.BASE_URL;
  }

  protected getApiUrl(): string {
    return this.getBaseUrl() + 'api/';
  }

  private getFullUrl(service: string): string {
    return this.getApiUrl() + service;
  }

  get<T>(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(this.getFullUrl(path), { params }); //.pipe(catchError(this.handleError));
  }

  getFile<T>(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(this.getFullUrl(path), {
      params: params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob'
    });
  }

  put<T>(path: string, body: Object = {}): Observable<any> {
    return this.http.put(this.getFullUrl(path), JSON.stringify(body), this.httpOptions); //.pipe(catchError(this.handleError));
  }

  post<T>(path: string, body: Object = {}): Observable<any> {
    return this.http.post(this.getFullUrl(path), JSON.stringify(body), this.httpOptions); //.pipe(catchError(this.handleError));
  }

  patch<T>(path: string, body: Object = {}): Observable<any> {
    return this.http.patch(this.getFullUrl(path), JSON.stringify(body), this.httpOptions); //.pipe(catchError(this.handleError));
  }

  delete<T>(path): Observable<any> {
    return this.http.delete(this.getFullUrl(path), this.httpOptions); ////.pipe(catchError(this.handleError));
  }
}
